import { type Ref, ref } from 'vue'

import type { VDialogPlacement } from '../types.ts'
import { bus } from '../utils/bus.ts'

export interface Dialog {
  id: number
  props: {
    closeOnPressEscape: boolean
    closeOnRouteChange: boolean
    index?: number
  }
  close: () => void
  wrapper: Ref<HTMLDivElement | null>
}

let counter = ref(0)

const placementToTransition: Record<VDialogPlacement, string> = {
  center: 'v-dialog-fade',
  fullscreen: 'v-fade',
  left: 'v-slide-in-right',
  right: 'v-slide-in-left',
  top: 'v-slide-in-top',
  bottom: 'v-slide-in-bottom',
}

let container = document.getElementById('v-dialogs-container')

if (!container) {
  container = document.createElement('div')
  container.id = 'v-dialogs-container'
  document.body.appendChild(container)
}

// Keep track of all visible dialogs.
// The last dialog that toggled visible should be closed when pressing escape.
const visibleDialogs: Dialog[] = []

document.addEventListener('keydown', (event) => {
  const key = event.key
  const target = event.target as HTMLElement

  if (key === 'Tab') {
    const dialog = visibleDialogs.at(-1)

    if (dialog && !dialog.wrapper.value?.contains(target)) {
      return event.preventDefault()
    }
  }

  if (key !== 'Escape') return

  const dialog = visibleDialogs.at(-1)

  if (dialog?.props.closeOnPressEscape) {
    dialog.close()
  }
})

bus.on('afterRouteChange', () => {
  for (const dialog of visibleDialogs.reverse()) {
    if (dialog.props.closeOnRouteChange) {
      dialog.close()
    } else {
      return
    }
  }
})

export function useDialogs() {
  return {
    visibleDialogs,
    placementToTransition,
    counter,
  }
}
